module.exports = __webpack_public_path__ + "img/job-sn.0491849.png";